import {
    $isElementNode,
    EditorConfig, ElementNode, NodeKey, RangeSelection, SerializedElementNode,
    Spread
} from "lexical"
import {$createFontColorNode, FontColorType} from "../font-color-plugin"
import {addClassNamesToElement} from "@lexical/utils"
import {$createBadgeNode, BadgeType} from "../../badge/badge-plugin";

export type SerializedFontColorNode = Spread<
    {
        fontColorType: FontColorType
    },
    SerializedElementNode
>

export class FontColorNode extends ElementNode {

    __fontColorType: FontColorType
    __badgeType: BadgeType
    constructor(fontColorType: FontColorType, key?: NodeKey) {
        super(key)
        this.__badgeType = BadgeType.BROWN
        this.__fontColorType = fontColorType
    }

    static getType(): string {
        return 'font-color-node' // just unique string
    }

    static clone(node: FontColorNode): FontColorNode {
        return new FontColorNode(node.__fontColorType, node.__key)
    }

    static importJSON(serializedNode: SerializedFontColorNode): FontColorNode {
        return $createFontColorNode(serializedNode.fontColorType)
    }

    setType(value:FontColorType) {
        // getWritable() creates a clone of the node
        // if needed, to ensure we don't try and mutate
        // a stale version of this node.
        const self = this.getWritable()
        self.__fontColorType = value
    }

    getType() {
        const self = this.getLatest()
        return self.__fontColorType
    }

    exportJSON() {
        return {
            ...super.exportJSON(),
            type        : FontColorNode.getType(),
            fontColorType   : this.__fontColorType
        }
    }

    createDOM(config: EditorConfig): HTMLElement {
        const element = document.createElement('span');
        addClassNamesToElement(element, config.theme['font-color'], this.__fontColorType)
        return element
    }

    updateDOM(prevNode: FontColorNode, dom: HTMLElement, config: EditorConfig): boolean {
        return false;
    }

    insertNewAfter(
        selection: RangeSelection,
        restoreSelection = true,
    ): null | ElementNode {
        const element = this.getParentOrThrow().insertNewAfter(
            selection,
            restoreSelection,
        );
        if ($isElementNode(element)) {
            const linkNode = $createBadgeNode(this.__badgeType)
            element.append(linkNode)
            return linkNode
        }
        return null
    }

    canInsertTextBefore(): false {
        return false;
    }

    canInsertTextAfter(): false {
        return false;
    }

    canBeEmpty(): false {
        return false;
    }

    isInline(): true {
        return true;
    }
}
